import { render } from "./AttendanceConfiguration.vue?vue&type=template&id=6ac3cb88&scoped=true"
import script from "./AttendanceConfiguration.vue?vue&type=script&lang=js"
export * from "./AttendanceConfiguration.vue?vue&type=script&lang=js"

import "./AttendanceConfiguration.vue?vue&type=style&index=0&id=6ac3cb88&lang=scss&scoped=true"

import exportComponent from "C:\\xampp3\\htdocs\\a\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ac3cb88"]])

export default __exports__